module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/shopping-bag.svg?2417d06955897b49595faa6edb51adb2";